import ResourceService from './resource.service'
import Vue from 'vue'

class WorkflowInstanceService extends ResourceService {
  static get resource() {
    return 'workflow-instance'
  }

  static cancelRequest(id) {
    const url = `${this.resource}/${id}/cancel`
    return new Promise((resolve, reject) => {
      Vue.axios
        .put(url)
        .then(({ data }) => {
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}

export default WorkflowInstanceService
